var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation1Solid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.6276C20 19.1647 19.6957 19.694 19.1124 20.1715C18.5291 20.6491 17.6836 21.0609 16.6464 21.3729C15.6092 21.6848 14.4103 21.8878 13.1494 21.965C11.8885 22.0422 10.6021 21.9913 9.39733 21.8165C8.19253 21.6418 7.10416 21.3483 6.2228 20.9604C5.34145 20.5725 4.69261 20.1015 4.33029 19.5866C3.96797 19.0717 3.90264 18.5277 4.13975 18",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24396 11.0272C4.5358 7.13749 7.49047 2.75 12 2.75C16.5095 2.75 19.4642 7.13749 17.756 11.0273L14.9723 17.3662C14.4766 18.4952 13.3125 19.25 12 19.25C10.6875 19.25 9.52344 18.4952 9.02768 17.3662L6.24396 11.0272Z",
    stroke: "#fff",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 2,
    stroke: "#fff",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation1Solid);
export default __webpack_public_path__ + "static/media/location1-solid.ca8903157a7bc2893af9af61adf3219f.svg";
export { ForwardRef as ReactComponent };